// Environment-based configuration for Lyndus Front Client
export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'https://client.lyndus.dev';
export const APP_USER_URL = process.env.VUE_APP_APP_USER_URL || 'https://appuser.lyndus.dev';
export const BM_URL = process.env.VUE_APP_BM_URL || 'https://bm.lyndus.dev';
export const BS_URL = process.env.VUE_APP_BS_URL || 'https://bs.lyndus.dev';
export const CLIENT_URL = process.env.VUE_APP_CLIENT_URL || 'https://client.lyndus.dev';
export const BONDER_URL = process.env.VUE_APP_BONDER_URL || 'https://bonder.lyndus.dev';
export const BANKING_URL = process.env.VUE_APP_BANKING_URL || 'https://banking.lyndus.dev';

// Environment variables
export const ENVIRONMENT = process.env.VUE_APP_ENVIRONMENT || 'dev';
export const IS_PRODUCTION = process.env.VUE_APP_IS_PRODUCTION === 'true';
export const DEBUG = process.env.VUE_APP_DEBUG === 'true';
export const SHOW_LOGS = process.env.VUE_APP_SHOW_LOGS === 'true';

// Original API URL for backward compatibility
export const API_URL = process.env.VUE_APP_API_URL || API_BASE_URL;

// Default export for backward compatibility
export default API_URL;
